<div class="content-container lca-view-mode" *ngIf="lcaDetails">
    <div class="row" class="page-heading">
        <h5 class="labelText mb-2">View LCA</h5>
    </div>
    <div class="row">
        <button class="back-button back-btn-white-bg pl-0" (click)="backToOriginPage()"><i
                class="fa fa-chevron-circle-left" aria-hidden="true"></i>
            Back
        </button>
    </div>

    <div class="box-shadow">
        <div class="p-4 padding-bottom-0">
            <div class="row">
                <div class="col-md-2">
                    <h3 class="mb-4">LCA Details</h3>
                </div>
                <div class="col-md-1">
                    <div class="row" >
                        <mat-icon matTooltip="settings menu" class="mr-1 icn settingsBorder" [matMenuTriggerFor]="menu">
                            <mat-icon>settings</mat-icon>
                            <mat-icon>keyboard_arrow_down</mat-icon>
                        </mat-icon>
                        <mat-menu #menu="matMenu">                                               
                            <button mat-menu-item matTooltip="Post LCA" (click)="openPostLcaModal(lcaDetails.lcaApplication)" *ngIf="lcaDetails.lcaApplication.status?.code == 'LCAASSIGN'">Post LCA</button>
                            <button mat-menu-item matTooltip="Withdraw LCA" (click)="openWithdrawLcaModal(lcaDetails.lcaApplication)" *ngIf="lcaDetails.lcaApplication.status?.code == 'LCAASSIGN' || lcaDetails.lcaApplication.status?.code == 'LCACERT'">Withdraw LCA</button>                                                    
                            <button mat-menu-item matTooltip="Duplicate LCA" (click)="duplicateLCA(lcaDetails.lcaApplication, true)">Duplicate LCA</button>  
                            <button mat-menu-item matTooltip="Delete"  (click)="handleDelete(lcaDetails.lcaApplication.id)">Delete</button>
                        </mat-menu>
                    </div>
                </div>
            </div>
            
            <div class="row">
                <div class="form-group col-md-4">
                    <label class="label-cls">LCA Case No.</label>
                    <p>{{ lcaDetails.lcaApplication.caseNumber }}</p>
                </div>

                <div class="form-group col-md-4">
                    <label class="label-cls">Certified</label>
                    <p>{{ lcaDetails.lcaApplication.isCertifiedLCA ? 'Yes' : 'No' }}</p>
                </div>
            </div>
        </div>
        <div class="view-mode-bg">
            <div class="p-4 padding-bottom-0">
                <div class="row">
                    <h5 class="col-md-8 labelText"> Employment-Based Nonmigrant Visa Information </h5>
                </div>

                <!-- Visa Classification Type -->
                <div class="row">
                    <div class="form-group col-md-4">
                        <label class="label-cls">Visa Classification Type</label>
                        <p>{{ lcaDetails.lcaApplication.visaType?.code }}</p>
                    </div>
                </div>

                <div class="col-md-12 p-0">
                    <hr class="dashed-border">
                </div>
            </div>

            <!-- Temporary Need Information -->
            <div class="p-4 padding-top-0">
                <h5 class="col-md-12 labelText"> Temporary Need Information </h5>
                <div class="row mt-2">
                    <!-- Job Title -->
                    <div class="form-group col-md-4">
                        <label class="label-cls">Job Title</label>
                        <p>{{ lcaDetails.lcaApplication.jobTitle }}</p>
                    </div>

                    <!-- SOC Code -->
                    <div class="form-group col-md-4">
                        <label class="label-cls">SOC Code</label>
                        <p>{{ lcaDetails.lcaApplication.socCode }}</p>
                    </div>

                    <!-- SOC (ONET/OES) Occupation Title -->
                    <div class="form-group col-md-4">
                        <label class="label-cls">SOC (ONET/OES) Occupation Title</label>
                        <p>{{ lcaDetails.lcaApplication.socTitle }}</p>
                    </div>
                </div>

                <!-- Is this a full-time position? -->
                <div class="row mt-2">
                    <div class="col-4 mt-1 pl-3">
                        <label class="control-lbl mt-2 label-cls">Is this a full-time position?</label>
                        <p>{{ lcaDetails.lcaApplication.isFullTime ? 'Yes' : 'No' }}</p>
                    </div>

                    <!-- Employment Start Date -->
                    <div class="col-4">
                        <div class="col-7 p-0">
                            <label class="control-lbl label-cls d-block">Employment Start Date</label>
                            <p>{{ lcaDetails.lcaApplication.employmentStartDate | date: 'MM/dd/yyyy' }}</p>
                        </div>
                    </div>

                    <!-- Employment End Date -->
                    <div class="col-4">
                        <div class="col-7 p-0">
                            <label class="control-lbl label-cls d-block">Employment End Date</label>
                            <p>{{ lcaDetails.lcaApplication.employmentEndDate | date: 'MM/dd/yyyy' }}</p>
                        </div>
                    </div>
                </div>

                <!-- Total Worker Position -->
                <div class="row mt-2">
                    <div class="col-4">
                        <div class="col-7 p-0">
                            <label class="control-lbl mt-2 label-cls">Total Worker Position</label>
                            <p>{{ lcaDetails.lcaApplication.totalCount }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Indicate Total Workers in each applicable category -->
            <div class="p-4 padding-top-0">
                <h5 class="col-md-12 labelText">Indicate Total Workers in each applicable category</h5>

                <div class="row mt-2">
                    <!-- New Employment -->
                    <div class="form-group col-md-4">
                        <label class="label-cls">New Employment</label>
                        <p>{{ lcaDetails.lcaApplication.newEmploymentCount }}</p>
                    </div>

                    <!-- Continuation of Employment -->
                    <div class="form-group col-md-4">
                        <label class="label-cls">Continuation of Employment</label>
                        <p>{{ lcaDetails.lcaApplication.continueApprovedCount }}</p>
                    </div>

                    <!-- Change in Employment -->
                    <div class="form-group col-md-4">
                        <label class="label-cls">Change in Employment</label>
                        <p>{{ lcaDetails.lcaApplication.changeApproveCount }}</p>
                    </div>
                </div>

                <!-- Additional Categories -->
                <div class="row">
                    <!-- New Concurrent Employment -->
                    <div class="col-4">
                        <div class="col-7 p-0">
                            <label class="control-lbl mt-2 label-cls">New Concurrent Employment</label>
                            <p>{{ lcaDetails.lcaApplication.concurrentEmploymentCount }}</p>
                        </div>
                    </div>

                    <!-- Change in Employer -->
                    <div class="col-4">
                        <div class="col-7 p-0">
                            <label class="control-lbl mt-2 label-cls">Change in Employer</label>
                            <p>{{ lcaDetails.lcaApplication.employerChangeCount }}</p>
                        </div>
                    </div>

                    <!-- Amended Petition -->
                    <div class="col-4">
                        <div class="col-7 p-0">
                            <label class="control-lbl mt-2 label-cls">Amended Petition</label>
                            <p>{{ lcaDetails.lcaApplication.amendedPetitionCount }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="view-mode-bg">
            <div class="p-4 padding-top-0">
                <h5 class="col-md-12 labelText"> Employer Information </h5>
                <div class="row mt-2">
                    <!-- Job Title -->
                    <div class="form-group col-md-4">
                        <label class="label-cls">Company Name</label>
                        <p>{{ lcaDetails.lcaApplication.company.companyName }}</p>
                    </div>
                </div>

                <div class="row mt-2">
                    <!-- Federal Employer Identification Number -->
                    <div class="col-4 mt-1 pl-3">
                        <label class="control-lbl mt-2 label-cls">Federal Employer Identification Number</label>
                        <p>{{ lcaDetails.lcaApplication.company.feiNo }}</p>
                    </div>

                    <!-- NAICS Code -->
                    <div class="col-4">
                        <div class="col-7 p-0">
                            <label class="control-lbl label-cls d-block">NAICS Code</label>
                            <p>{{ lcaDetails.lcaApplication.company.naicsCode }}</p>
                        </div>
                    </div>
                </div>

                <div class="row mt-2">
                    <!-- Phone Number -->
                    <div class="col-4 mt-1 pl-3">
                        <label class="control-lbl mt-2 label-cls">Phone Number</label>
                        <p>{{ lcaDetails.lcaApplication.company?.phoneContacts[0]?.phoneNo }}</p>
                    </div>

                    <!-- Ext -->
                    <div class="col-4">
                        <div class="col-7 p-0">
                            <label class="control-lbl label-cls d-block">Ext</label>
                            <p>{{ lcaDetails.lcaApplication.company?.phoneContacts[0]?.countryCode?.phoneCode }}</p>
                        </div>
                    </div>
                </div>

                <div class="row mt-2">
                    <!-- Address -->
                    <div class="col-4 mt-1 pl-3">
                        <label class="control-lbl mt-2 label-cls">Address</label>
                        <p class="mb-0" *ngIf="lcaDetails.lcaApplication.company?.address?.length">{{ lcaDetails.lcaApplication.company?.address[0]?.addressLine1 }},</p>
                        <p class="mb-0" *ngIf="lcaDetails.lcaApplication.company?.address?.length">{{ lcaDetails.lcaApplication.company?.address[0]?.addressLine2 }},</p>
                        <p class="mb-0" *ngIf="lcaDetails.lcaApplication.company?.address?.length">{{ lcaDetails.lcaApplication.company?.address[0]?.countryCode?.countryName }},</p>
                        <p class="mb-0" *ngIf="lcaDetails.lcaApplication.company?.address?.length">{{ lcaDetails.lcaApplication.company?.address[0]?.city }},{{
                            lcaDetails.lcaApplication.company?.address[0]?.postCode }}</p>
                    </div>
                </div>
            </div>
        </div>


        <div class="view-mode-bg">
            <div class="p-4 padding-top-0" *ngFor="let info of lcaDetails.placeList; let i = index">
                <h5 class="col-md-12 labelText">Places of Employment</h5>

                <div class="row mt-2 p-3">
                    <h6>{{ i + 1 }}. Place of Employment</h6>
                </div>

                <div class="row mt-2">
                    <div class="form-group col-md-4">
                        <label>Address Line 1</label>
                        <div class="row">{{ info.addressDTO.addressLine1 }}</div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Address Line 2</label>
                        <div class="row">{{ info.addressDTO.addressLine2 }}</div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>City</label>
                        <div class="row">{{ info.addressDTO.city }}</div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="form-group col-md-4">
                        <label>County</label>
                        <div class="row">{{ info.addressDTO.county }}</div>
                    </div>

                    <div class="form-group col-md-4">
                        <label>State/District/Territory</label>
                        <div class="row">{{ info.addressDTO.stateProvinceName || info.addressDTO.stateProvinceCode }}
                        </div>
                    </div>

                    <div class="form-group col-md-4">
                        <label>Postal Code</label>
                        <div class="row">{{ info.addressDTO.postalCode }}</div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="form-group col-md-4">
                        <label>Wage paid to non-immigrant - from</label>
                        <div class="row">{{ info.wageRangeFrom }}</div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Wage paid to non-immigrant - to</label>
                        <div class="row">{{ info.wageRangeTo }}</div>
                    </div>

                    <div class="form-group col-md-4">
                        <label>Wage paid to non-immigrant - per</label>
                        <div class="row">{{ getDisplayString(info.wageRangeTypeCode) }}</div>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="form-group col-md-4">
                        <label>Prevailing wage paid - rate</label>
                        <div class="row">{{ info.prvlWageRate }}</div>
                    </div>
                    <div class="form-group col-md-4">
                        <label>Prevailing wage paid - per</label>
                        <div class="row">{{ getDisplayString(info.prvWageTypeCode) }}</div>
                    </div>

                    <div class="form-group col-md-4">
                        <label>Prevailing wage level</label>
                        <div class="row">{{ getDisplayString(info.prvWageLevelTypeCode) }}</div>
                    </div>
                </div>

                <div *ngIf="i < lcaDetails.placeList.length - 1">
                    <hr />
                </div>
            </div>
        </div>

        <div class="p-4 padding-top-0">
            <div>
                <div class="form-group col-md-12 pt-2">
                    <h5 class="col-md-12 pl-0 labelText">Notes</h5>
                    <div class="col-md-12 pl-0 valueTxt">{{lcaDetails?.lcaApplication?.comment}}</div>
                </div>
            </div>
            <div class="row pl-2">
                <div class="client-display-box col-md-10">
                    <mat-list *ngIf="assignmentList && assignmentList.length >0" class="client-list-print">
                        <div class="mat-subheader-clients-added pl-0" mat-subheader>LCA Assignment Details</div>
                        <mat-list-item>
                            <div class="clients-list-item-partition">
                                <div mat-line>Task ID</div>
                            </div>
                            <div class="clients-list-item-partition">
                                <div mat-line>Beneficairy Name</div>
                            </div>
                            <div class="clients-list-item-partition">
                                <div mat-line>Visa Type</div>
                            </div>

                            <div class="clients-list-item-partition">
                                <div mat-line>Petition Type</div>
                            </div>
                        </mat-list-item>
                        <mat-list-item
                            *ngFor="let item of assignmentList; let i = index;let even = even;let first = first;let last = last;"
                            [ngClass]="{'evenBg':even,'border-top-radius':first,'border-bottom-radius':last}">
                            <div class="clients-list-item-partition">
                                <div mat-line> {{ item?.superTaskId }} </div>

                            </div>

                            <div class="clients-list-item-partition">
                                <div mat-line> {{ item?.beneficiaryFirstName }} {{ item?.beneficiaryMiddleName }} {{
                                    item?.beneficiaryLastName }} </div>
                            </div>

                            <div class="clients-list-item-partition">
                                <div mat-line> {{item?.visaTypeCode}} </div>
                            </div>



                            <div class="clients-list-item-partition">
                                <div mat-line>
                                    {{item?.petitionTypeName}}

                                </div>
                            </div>

                        </mat-list-item>
                    </mat-list>
                </div>

                <div class="client-display-box col-md-10 mb-2">
                    <mat-list *ngIf="listUploadedFiles && listUploadedFiles.length >0" class="client-list-print">
                        <div class="mat-subheader-clients-added pl-0" mat-subheader>List of Documents</div>
                        <mat-list-item>
                            <div class="first-item">
                                <div mat-line></div>
                            </div>
                            <div class="clients-list-item-partition">
                                <div mat-line>Document Type</div>
                            </div>
                            <div class="clients-list-item-partition">
                                <div mat-line>Document</div>
                            </div>

                            <div class="clients-list-item-partition">
                                <div mat-line></div>
                            </div>
                        </mat-list-item>
                        <mat-list-item
                            *ngFor="let item of listUploadedFiles; let i = index;let even = even;let first = first;let last = last;"
                            [ngClass]="{'evenBg':even,'border-top-radius':first,'border-bottom-radius':last}">
                            <div class="first-item">
                                <div class="numberCircle">{{i+1}}</div>
                            </div>

                            <div class="clients-list-item-partition">
                                <div mat-line> {{ item?.fileCategory?.name }} </div>
                            </div>

                            <div class="clients-list-item-partition">
                                <div mat-line> {{item?.fileName}} </div>
                            </div>



                            <div class="clients-list-item-partition">
                                <div mat-line class="text-right">
                                    <a *ngIf="item.fileLocation" [href]="envPath + item.fileLocation.substring(23)"
                                        target="_blank" download>
                                        <i class="fa fa-download fa-lg icn" aria-hidden="true"></i>
                                    </a>

                                </div>
                            </div>

                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>

    </div>
</div>